module.exports = __webpack_public_path__ + "img/btn_random.18198d2b.svg";